"use client"

import React from 'react';
import { cn } from '@/lib/utils';

interface Feature {
  title: string;
  description: string;
}

interface FeaturesProps {
  className?: string;
  title?: string;
  osobData?: {
    title?: string;
    description?: string;
    items?: Feature[];
  } | null;
}

export default function Features({ 
  className, 
  title,
  osobData
}: FeaturesProps) {
  // Если нет данных, не показываем компонент
  if (!osobData || !osobData.items || osobData.items.length === 0) {
    return null;
  }
  
  const displayTitle = title || osobData.title || 'Особенности';
  const features = osobData.items.map((item, index) => ({
    id: index + 1,
    title: item.title,
    description: item.description,
  }));
  return (
    <section className={cn('py-6 sm:py-16', className)}>
      <div className="w-full">
        <h2 className="text-xl sm:text-3xl font-semibold text-slate-900 mb-6 sm:mb-12">
          {displayTitle}
        </h2>
        
        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-8">
          {features.map((feature) => (
            <div 
              key={feature.id} 
              className="flex flex-col gap-2 sm:gap-2.5"
            >
              {/* Icon Circle */}
              <div className="flex-shrink-0 w-5 h-5 sm:w-[45px] sm:h-[45px] rounded-full bg-slate-900" />
              
              {/* Title */}
              <h3 className="text-sm sm:text-lg font-semibold text-slate-900 leading-snug">
                {feature.title}
              </h3>
              
              {/* Description */}
              <p className="text-xs sm:text-base text-slate-700 leading-snug">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

